module.exports = __webpack_public_path__ + "static/media/pulpo.b20556c9.png";